export type AIMatchingFieldKey =
  | 'workHistory'
  | 'biography'
  | 'hobbies'
  | 'departments'
  | 'gender'
  | 'ethnicity'
  | 'firstGenStudent'
  | 'disability'
  | 'major'
  | 'university'
  | 'industry'
  | 'title'
  | 'topics'
  | 'industries';

export const AI_MATCHING_FIELD_OPTIONS: Array<{ key: AIMatchingFieldKey; label: string }> = [
  { key: 'workHistory', label: 'Work History' },
  { key: 'biography', label: 'Biography' },
  { key: 'hobbies', label: 'Hobbies & Interests' },
  { key: 'departments', label: 'Departments' },
  { key: 'gender', label: 'Gender' },
  { key: 'ethnicity', label: 'Ethnicity' },
  { key: 'firstGenStudent', label: 'First Generation Student' },
  { key: 'disability', label: 'Disability' },
  { key: 'major', label: 'Major' },
  { key: 'university', label: 'University' },
  { key: 'industry', label: 'Industry' },
  { key: 'title', label: 'Title' },
  { key: 'topics', label: 'Topics' },
  { key: 'industries', label: 'Industries' }
];

export const ALWAYS_ON_AI_FIELD_LABEL = 'Learning Objectives';

export type AIMatchingFieldsConfig = Partial<Record<AIMatchingFieldKey, boolean>>;
